import { axios } from './axios';

export const switchAccountShippingMethod = async (email: string) => {
  return await axios.post('switch_account_shipping_method', { account_email: email });
};
